<template>
    <div class="d-flex flex-column" id="app">
        <loading v-if="$root.carregando"></loading>
        <topo
            :logoURL='logoURL'
            :sigla='sigla'
            :nome='nome'
            homeLink="/"
            :itens-menu="itens_menu"
            :usuario='usuario'
            :logout-callback='logout'
        ></topo>

        <div class="conteudo">
            <router-view></router-view>
        </div>

        <rodape
            :logoURL='logoURL'
            :versao='versao'
        ></rodape>

    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import loading from '../components/Loading';
import topo from '../layout/topo';
import rodape from '../layout/rodape';

export default {

    components: {
        loading,
        topo,
        rodape
    },


    data(){
        return {
           usuario: null,
           logoURL: 'https://assets.pbh.gov.br/assets/pbh/images/logo-pbh-cor-pos.svg',
        }
    },

    methods: {
        logout() {
            this.$store.dispatch("LOGOUT_REQUEST");
        },
    },

    computed: {

        ...mapGetters(['isAuthenticated', 'userInfo']),

        sigla() {
            return this.$env.VUE_APP_SIGLA;
        },
        nome() {
            return this.$env.VUE_APP_NOME;
        },
        versao() {
            return this.$version.VUE_APP_VERSAO;
        },
        /**
         * Retorna os itens do menu
         */

        itens_menu() {
            let itens = [];

            //MENU ADMIN
            //So exibe o menu administrativo para usuarios autenticados com login do AD
            if(this.isAuthenticated && this.userInfo.origem === this.$constantes.usuario.ORIGEM_LOGIN_AD){
                itens = [
                    { titulo: 'Edições', to: { name: 'edicoes'}},
                    { titulo: 'Categorias', to: { name: 'categoriasAto'}},
                    { titulo: 'Expediente', to: { name: 'expediente'}},
                    { titulo: 'Orgãos', to: { name: 'orgao'}},
                ];
            } else {
                itens = [
                    { titulo: 'Verificar autenticidade', to: { name: 'verificarautenticidade'}},
                    { titulo: 'Expediente', to: { name: 'expedienteview'}},
                ];
            }
            return itens;
        },

    },
    watch: {
        userInfo(usuario) {
            if(this.isAuthenticated && this.userInfo.origem === this.$constantes.usuario.ORIGEM_LOGIN_AD) {
                this.usuario = usuario;
            }
        }
    }
}
</script>

